import Reflux from 'reflux'
import Proxies from 'Components/proxies'
const { GET, POST } = Proxies
import keyMirror from 'keymirror'
import 'moment/locale/da'
import { OrderActions } from './orderStore'
import { toast } from 'react-toastify'

export const STATUS = keyMirror({
  IS_FETCHING: null,
  FETCHING_ERROR: null,
  UPDATE_SUCCESS: null,
  UPDATE_ERROR: null,
  DELETE_ERROR: null,
  DELETE_SUCCESS: null,
  TAKING_INPUT: null,
  IS_SAVING: null,
  REDIRECT: null
})

export const PurchaseOrderStoreActions = Reflux.createActions([
  'getPurchaseOrders',
  'getPurchaseOrdersPaged',
  'setPurchaseOrdersQuery',
  'getPurchaseOrdersToReceive',
  'getPurchaseOrdersToReceivePaged',
  'setPurchaseOrdersToReceiveQuery',
  'addPurchaseOrderLine',
  'removePurchaseOrderLine',
  'updatePurchaseOrderLine',
  'savePurchaseOrder',
  'savePurchaseOrderRedirectToSend',
  'updatePurchaseOrderField',
  'clearFormToast',
  'updateSupplier',
  'getMsbAdminUsers',
  'updateOurRef',
  'getProductsFromSupplier',
  'createNewPurchaseOrder',
  'getPurchaseOrderDetails',
  'createEmptyPurchaseOrderDetails',
  'formatDate',
  'generatePurchaseOrderPdf',
  'generatePurchaseOrder',
  'sendGraphMail',
  'approvedOrdered',
  'orderViaApi',
  'orderAllViaApi',
  'clearToast',
  'getPurchaseOrdersToReceive',
  'fetchMultiplePurchaseOrders',
  'receiveLines',
  'deletePurchaseOrder',
  'getStockLocations',
  'getStockLocationsForVariations',
  'setProductStockLocation',
  'mergePurchaseOrders',
  'getPurchaseOrderOverview',
  'getOrdersBySupplierID',
  'createPurchaseOrderFromOverview',
  'reportPurchaseOrderError',
  'getSuppliers',
  'setEANonVariation'
])

export class PurchaseOrderStore extends Reflux.Store {
  constructor(props) {
    super(props)
    this.listenables = PurchaseOrderStoreActions
    this.state = {
      showProductsLoading: false,
      pdfBlob: null,
      pdfBytes: null,
      pdfBase64: null,
      showPdfPreview: false,
      pdfReady: false,
      showPdfFailed: false,
      status: null,
      purchaseOrders: [],
      purchaseOrdersLoading: false,
      purchaseOrderOverviewLoading: false,
      purchaseOrdersToReceive: [],
      purchaseOrdersToReceiveDetails: [],
      suppliers: [],
      products: [],
      currencies: [
        { name: 'DKK', value: 'DKK', selected: true },
        { name: 'EUR', value: 'EUR', selected: false },
        { name: 'SEK', value: 'SEK', selected: false },
        { name: 'USD', value: 'USD', selected: false }
      ],
      purchaseOrderID: null,
      purchaseOrderDetails: {
        orderType: null,
        dateCreated: null,
        purchaseOrderNote: '',
        purchaseOrderNumber: null,
        purchaseOrderStatus: '',
        supplier: null,
        isDropShip: false,
        alternativeAttPerson: '',
        buyerUserID: null,
        alternativeDeliveryTime: '',
        alternativeMail: '',
        purchaseOrderlines: [],
        currency: null,
        theirRef: '',
        ourRef: '',
        deliveryAddress1: 'Upgrader A/S',
        deliveryAddress2: 'Ellekær 6',
        deliveryAddress3: '2730 Herlev',
        deliveryAddress4: 'Danmark',
        deliveryAddress5: '',
        removed: false
      },
      stockLocations: [],
      productStockLocations: [],
      purchaseOrderOverviewTotals: [],

      purchaseOrdersQuery: {
        page: 1,
        pageSize: 10,
        searchTerm: '',
        sortField: 'PurchaseOrderNumber',
        sortDir: 'DESC',
        statusIn: [],
        supplierID: null,
        isDropship: null,
        dateFrom: null,
        dateTo: null
      },
      purchaseOrdersTotalCount: 0,

      purchaseOrdersToReceiveQuery: {
        page: 1,
        pageSize: 10,
        searchTerm: '',
        supplierID: null,
        statusIn: [],
        isDropship: null,
        dateFrom: null,
        dateTo: null,
        sortField: 'PurchaseOrderNumber',
        sortDir: 'DESC'
      },
      purchaseOrdersToReceiveTotalCount: 0,
      redirectToSend: 0
    }
  }

  createEmptyPurchaseOrderDetails() {
    this.setState({
      dateCreated: Date.now(),
      purchaseOrderDetails: {
        purchaseOrderNote: '',
        purchaseOrderNumber: null,
        purchaseOrderStatus: '',
        supplier: null,
        isDropShip: false,
        alternativeAttPerson: '',
        buyerUserID: null,
        alternativeDeliveryTime: '',
        alternativeMail: '',
        purchaseOrderlines: [],
        currency: 'DKK',
        theirRef: '',
        ourRef: '',
        deliveryAddress1: 'Upgrader A/S',
        deliveryAddress2: 'Ellekær 6',
        deliveryAddress3: '2730 Herlev',
        deliveryAddress4: 'Danmark',
        deliveryAddress5: '',
        removed: false
      }
    })
  }

  getPurchaseOrdersPaged(override = {}) {
    const payload = { ...this.state.purchaseOrdersQuery, ...override }

    this.setState({ status: STATUS.IS_FETCHING, purchaseOrdersQuery: payload })
    POST('purchaseOrders/poolPaged', payload).then(responseJSON => {
      const nextState = {
        purchaseOrders: [],
        purchaseOrdersTotalCount: 0,
        status: null
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          const items = responseJSON.data
          const total = responseJSON.pagination.total

          nextState.purchaseOrders = items
          nextState.purchaseOrdersTotalCount = total
          nextState.status = null
        }
      }
      this.setState(nextState)
    })
  }

  setPurchaseOrdersQuery(patch) {
    const query = { ...this.state.purchaseOrdersQuery, ...patch }
    this.getPurchaseOrdersPaged(query)
  }

  getPurchaseOrders() {
    this.getPurchaseOrdersPaged({})
  }

  getPurchaseOrdersToReceivePaged(override = {}) {
    const payload = { ...this.state.purchaseOrdersToReceiveQuery, ...override }
    this.setState({ status: STATUS.IS_FETCHING, purchaseOrdersToReceiveQuery: payload })
    POST('purchaseOrders/poolReceivePaged', payload).then(responseJSON => {
      const nextState = {
        purchaseOrdersToReceive: [],
        purchaseOrdersToReceiveTotalCount: 0,
        status: null
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          const items = responseJSON.data
          const total = responseJSON.pagination?.total ?? 0
          nextState.purchaseOrdersToReceive = items
          nextState.purchaseOrdersToReceiveTotalCount = total
        }
      }
      this.setState(nextState)
    })
  }

  setPurchaseOrdersToReceiveQuery(patch) {
    const query = { ...this.state.purchaseOrdersToReceiveQuery, ...patch }
    this.getPurchaseOrdersToReceivePaged(query)
  }

  // Backward compat
  getPurchaseOrdersToReceive() {
    this.getPurchaseOrdersToReceivePaged({})
  }

  getPurchaseOrderDetails(id) {
    if (!id) {
      return
    }
    this.setState({ status: STATUS.IS_FETCHING })
    GET('purchaseOrders/fetch', { PurchaseOrderID: id }).then(responseJSON => {
      let nextState = {
        purchaseOrderDetails: {}
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          responseJSON.purchaseOrderlines.forEach(pol => (pol.status = pol.isReceived ? 'SUCCESS' : ''))
          nextState.purchaseOrderDetails = responseJSON
          this.getProductsFromSupplier(responseJSON.supplier?.SupplierID)
          nextState.status = STATUS.TAKING_INPUT
        }
      }
      this.setState(nextState)
    })
  }

  getSuppliers() {
    GET('suppliers/pool').then(responseJSON => {
      if (responseJSON) {
        this.setState({ suppliers: responseJSON })
      }
    })
  }

  getSupplierByUID(SupplierUID) {
    return new Promise((resolve, reject) => {
      GET('suppliers/fetchByUid', { SupplierUID })
        .then(responseJSON => {
          if (responseJSON && responseJSON.error) {
            resolve(null)
          } else {
            resolve(responseJSON)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  getProductsFromSupplier(supplierId) {
    this.setState({ setProductsLoading: true })
    let filterList = []
    let suppliers = []
    suppliers.push(supplierId)
    filterList.push({ column: 'Supplier.SupplierID', operator: 'EQUAL', values: suppliers })
    GET('products/pool', { filters: filterList }).then(responseJSON => {
      if (responseJSON) {
        this.setState({ products: responseJSON, setProductsLoading: false })
      }
    })
  }

  updatePurchaseOrderField(field) {
    let fieldName = field.target.name
    let fieldValue
    if (fieldName === 'removed') {
      fieldValue = field.target.checked ? 1 : 0
    } else {
      fieldValue = field.target.value
    }
    let purchaseOrderDetails = this.state.purchaseOrderDetails
    purchaseOrderDetails[fieldName] = fieldValue
    this.setState({ purchaseOrderDetails })
  }

  async updateSupplier(field) {
    let fieldName = field.target.name
    let supplierObject
    if (fieldName !== 'supplier') {
      return
    }
    const supplierId = field.target.value
    supplierObject = this.state.suppliers.find(s => s.SupplierID === Number(supplierId)) || null
    const supplierDetails = await this.getEconomicSupplierDetail(supplierObject.supplierUID)
    if (supplierDetails && String(supplierObject.supplierUID) === String(supplierDetails.supplierNumber)) {
      supplierObject.email = supplierDetails.email
      supplierObject.address = supplierDetails.address
    }
    let purchaseOrderDetails = this.state.purchaseOrderDetails
    purchaseOrderDetails.supplier = supplierObject
    purchaseOrderDetails.isDropShip = supplierObject ? supplierObject.isDropship : false
    this.setState({ purchaseOrderDetails })
  }

  updateOurRef(field) {
    const fieldName = field.target.name
    if (fieldName !== 'purchaser') return
    const buyerUserID = field.target.value
    const userObj = (this.state.msbAdminUsers || []).find(u => u.UserID === buyerUserID)
    let purchaseOrderDetails = this.state.purchaseOrderDetails
    purchaseOrderDetails.buyerUserID = buyerUserID
    purchaseOrderDetails.ourRef = userObj ? userObj.userName : ''
    this.setState({ purchaseOrderDetails })
  }

  getMsbAdminUsers() {
    GET('user/msb-admin-users').then(responseJSON => {
      if (responseJSON) {
        this.setState({ msbAdminUsers: responseJSON })
      }
    })
  }

  getEconomicSupplierDetail(SupplierUID) {
    return new Promise((resolve, reject) => {
      GET('suppliers/economicData', { SupplierUID })
        .then(responseJSON => {
          if (responseJSON && responseJSON.error) {
            resolve(null)
          } else {
            resolve(responseJSON)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  addPurchaseOrderLine(line) {
    const lines = [...this.state.purchaseOrderDetails.purchaseOrderlines, line]
    this.setState({
      purchaseOrderDetails: {
        ...this.state.purchaseOrderDetails,
        purchaseOrderlines: lines
      }
    })
  }

  removePurchaseOrderLine(index) {
    const lines = this.state.purchaseOrderDetails.purchaseOrderlines.filter((_, i) => i !== index)
    this.setState({
      purchaseOrderDetails: {
        ...this.state.purchaseOrderDetails,
        purchaseOrderlines: lines
      }
    })
  }

  savePurchaseOrder() {
    this.setState({ status: STATUS.IS_SAVING })
    POST('purchaseOrders/replace', this.state.purchaseOrderDetails).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        this.setState({ status: STATUS.UPDATE_SUCCESS })
        window.open(`/purchase-orders/details/` + responseJSON.PurchaseOrderID, '_self')
      } else {
        this.setState({ status: STATUS.UPDATE_ERROR })
      }
    })
  }

  savePurchaseOrderRedirectToSend() {
    POST('purchaseOrders/replace', this.state.purchaseOrderDetails).then(responseJSON => {
      this.setState({ redirectToSend: responseJSON.PurchaseOrderID })
    })
  }

  // updatePurchaseOrderLine({ index, line }) {
  //   const lines = this.state.purchaseOrderDetails.purchaseOrderlines.map((l, i) => i === index ? line : l)
  //   this.setState({
  //     purchaseOrderDetails: {
  //       ...this.state.purchaseOrderDetails,
  //       purchaseOrderlines: lines
  //     }
  //   })
  // }

  deletePurchaseOrder(PurchaseOrderID) {
    POST(`purchaseOrders/removePurchaseOrder`, { PurchaseOrderID }).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        this.setState({ status: STATUS.DELETE_SUCCESS })
      } else {
        this.setState({ status: STATUS.DELETE_ERROR })
      }
    })
  }

  receiveLines(recievePayload) {
    this.setState({ status: STATUS.IS_SAVING })
    POST('purchaseOrders/receivePurchaseOrder', recievePayload).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        const purchaseOrderIDs = recievePayload
          .flatMap(p => p.purchaseOrderLineIDs)
          .map(lineID => {
            const po = this.state.purchaseOrdersToReceiveDetails.find(po =>
              (po.purchaseOrderlines || []).some(line => line.purchaseOrderLineID === lineID)
            )
            return po ? po.PurchaseOrderID : null
          })
          .filter(Boolean)
        this.fetchMultiplePurchaseOrders([...new Set(purchaseOrderIDs)])
      } else {
        this.setState({ status: STATUS.UPDATE_ERROR })
      }
    })
  }

  generatePurchaseOrderPdf(pdfData) {
    this.setState({ pdfBlob: null, showPdfPreview: true, showPdfFailed: true, pdfReady: false })
    POST('purchaseorders/generatePdf', { data: pdfData }).then(responseJSON => {
      if (responseJSON && responseJSON.response) {
        const byteCharacters = atob(responseJSON.response)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const blobUrl = URL.createObjectURL(blob)
        this.setState({ pdfBlob: blobUrl, showPdfPreview: true, pdfBytes: byteArray, pdfReady: true })
      } else {
        this.setState({ pdfBlob: null, showPdfFailed: true })
      }
    })
  }

  clearToast() {
    this.setState({ status: null })
  }

  createNewPurchaseOrder() {
    this.setState({ status: STATUS.IS_SAVING })
    POST('purchase-orders', this.state.purchaseOrderDetails).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        this.setState({ status: STATUS.UPDATE_SUCCESS })
      } else {
        this.setState({ status: STATUS.UPDATE_ERROR })
      }
    })
  }

  async generatePurchaseOrder(orderLines) {
    if (!orderLines || !orderLines.length) return
    let isDropShip
    const supplierUID = orderLines[0].vendor
    const supplierObject = await this.getSupplierByUID(supplierUID)
    if (!supplierObject) {
      console.error('Supplier not found for supplierUID:', supplierUID)
      return
    }

    if (supplierObject.isDropship) {
      isDropShip = true
    } else {
      isDropShip = false
    }

    const purchaseOrderlines = orderLines.map(line => ({
      productVariationID: line.VariationID,
      productVariationUID: line.variationUID,
      description: isDropShip
        ? line.productTitle + '\n' + line.address.replaceAll(', ', '\n') + '\n' + line.phone + '\n' + line.email
        : line.productTitle,
      amountOfProducts: line.count || 1,
      amountReceived: 0,
      pricePerItem: line.productPrice,
      orderLineType: line.OrderlineID ? 'ORDER' : 'STOCK',
      orderLineID: line.OrderlineID || null,
      purchaseOrderLineNote: line.PurchaseOrderLineNote || null
    }))

    const purchaseOrder = {
      supplier: supplierObject,
      purchaseOrderlines: purchaseOrderlines,
      currency: 'DKK',
      theirRef: ' ',
      ourRef: Reflux.GlobalState.LoginStore.user.userName || '',
      deliveryAddress1: isDropShip ? ' ' : 'Upgrader A/S',
      deliveryAddress2: isDropShip ? ' ' : 'Ellekær 6',
      deliveryAddress3: isDropShip ? ' ' : '2730 Herlev',
      deliveryAddress4: isDropShip ? ' ' : 'Danmark',
      deliveryAddress5: '',
      alternativeMail: orderLines[0].email || '',
      alternativeDeliveryTime: '',
      buyerUserID: Reflux.GlobalState.LoginStore.user.UserID || '',
      purchaseOrderNote: '',
      purchaseOrderNumber: null,
      purchaseOrderStatus: '',
      isDropShip: isDropShip,
      alternativeAttPerson: '',
      dateCreated: Date.now(),
      removed: false
    }

    POST('purchaseOrders/replace', purchaseOrder).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        this.setState({ status: STATUS.UPDATE_SUCCESS })
        window.open(`/purchase-orders/details/` + responseJSON.PurchaseOrderID)
      } else {
        this.setState({ status: STATUS.UPDATE_ERROR })
      }
    })
  }

  sendGraphMail(emailProperties) {
    POST('communications/sendGraphMail', { emailProperties }).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        this.setState({ status: STATUS.UPDATE_SUCCESS })
        window.open(`/purchase-orders/all`, '_self')
      } else {
        this.setState({ status: STATUS.UPDATE_ERROR })
      }
    })
  }

  approvedOrdered(PurchaseOrderNumber) {
    POST('purchaseOrders/approveOrdered', { PurchaseOrderNumber }).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        this.setState({ status: STATUS.UPDATE_SUCCESS })
        window.open(`/purchase-orders`, '_self')
      } else {
        this.setState({ status: STATUS.UPDATE_ERROR })
      }
    })
  }

  async orderAllViaApi() {
    const poLines = this.state.purchaseOrderDetails?.purchaseOrderlines?.filter(pol => pol.status !== 'SUCCESS')
    for (const pol of poLines) {
      await this.orderViaApi(pol.purchaseOrderLineID)
    }
  }

  async orderViaApi(PurchaseOrderLineID) {
    this.setState({
      purchaseOrderDetails: {
        ...this.state.purchaseOrderDetails,
        purchaseOrderlines: [
          ...this.state.purchaseOrderDetails.purchaseOrderlines.map(l =>
            l.purchaseOrderLineID === PurchaseOrderLineID ? { ...l, status: 'PENDING', errorMessage: '' } : l
          )
        ]
      }
    })
    const responseJSON = await POST('purchaseOrders/orderViaApi', { PurchaseOrderLineID })
    if (responseJSON && !responseJSON.error) {
      this.setState({
        purchaseOrderDetails: {
          ...this.state.purchaseOrderDetails,
          purchaseOrderlines: [
            ...this.state.purchaseOrderDetails.purchaseOrderlines.map(l =>
              l.purchaseOrderLineID === PurchaseOrderLineID ? { ...l, status: 'SUCCESS', errorMessage: '' } : l
            )
          ]
        }
      })
    } else {
      this.setState({
        purchaseOrderDetails: {
          ...this.state.purchaseOrderDetails,
          purchaseOrderlines: [
            ...this.state.purchaseOrderDetails.purchaseOrderlines.map(l =>
              l.purchaseOrderLineID === PurchaseOrderLineID ? { ...l, status: 'ERROR', errorMessage: responseJSON.error.message } : l
            )
          ]
        }
      })
    }
    return responseJSON
  }

  fetchMultiplePurchaseOrders(purchaseOrderIDs) {
    if (this.state.status === STATUS.IS_FETCHING) {
      return
    }
    this.setState({ status: STATUS.IS_FETCHING })
    POST('purchaseOrders/fetchMultiple', { purchaseOrderIDs }).then(responseJSON => {
      let nextState = {
        purchaseOrdersToReceiveDetails: []
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          nextState.purchaseOrdersToReceiveDetails = responseJSON
          nextState.status = null
        }
      }
      this.setState(nextState)
    })
  }

  getStockLocations() {
    GET('stockLocations/pool').then(responseJSON => {
      let nextState = { stockLocations: [] }
      if (responseJSON.error) {
        nextState.status = STATUS.FETCHING_ERROR
      } else {
        nextState.stockLocations = responseJSON.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
      }
      this.setState(nextState)
    })
  }

  getStockLocationsForVariations(variationIds) {
    GET('stockLocations/getStockLocationsForVariations', { variationIds }).then(responseJSON => {
      let nextState = { productStockLocations: [] }
      if (responseJSON.error) {
        nextState.status = STATUS.FETCHING_ERROR
      } else {
        nextState.productStockLocations = responseJSON
      }
      this.setState(nextState)
    })
  }

  setProductStockLocation(productId, stockLocationId) {
    POST('stockLocations/setProductStockLocation', { ProductID: productId, StockLocationID: stockLocationId }).then(responseJSON => {
      let nextState = { productStockLocations: [] }
      if (responseJSON.error) {
        nextState.status = STATUS.FETCHING_ERROR
      } else {
        nextState.productStockLocations = this.state.productStockLocations.map(psl => {
          if (psl.ProductID === productId) {
            return { ...psl, StockLocationID: stockLocationId }
          } else {
            return psl
          }
        })
      }
      this.setState(nextState)
    })
  }

  mergePurchaseOrders(selectedPOs) {
    return new Promise((resolve, reject) => {
      if (!selectedPOs || selectedPOs.length < 2) return reject('Select at least two purchase orders')
      this.setState({ status: STATUS.IS_SAVING })
      const sourcePurchaseOrderID = selectedPOs[0]
      const targetPurchaseOrderID = selectedPOs[1]
      if (sourcePurchaseOrderID === targetPurchaseOrderID) return reject('Same purchase order')

      POST('purchaseOrders/merge', { sourcePurchaseOrderID, targetPurchaseOrderID }).then(responseJSON => {
        if (responseJSON && !responseJSON.error) {
          this.setState({ status: STATUS.UPDATE_SUCCESS })
          this.getPurchaseOrders()
          resolve(responseJSON)
        } else {
          this.setState({ status: STATUS.UPDATE_ERROR })
          reject(responseJSON?.error || 'Merge failed')
        }
      })
    })
  }

  getPurchaseOrderOverview() {
    this.setState({ purchaseOrderOverviewLoading: true })
    GET('purchaseOrders/getPurchaseOrderOverview').then(responseJSON => {
      let nextState = {
        purchaseOrderOverviewTotals: [],
        purchaseOrderOverviewLoading: false
      }
      if (responseJSON) {
        if (responseJSON.error) {
          nextState.status = STATUS.FETCHING_ERROR
        } else {
          nextState.purchaseOrderOverviewTotals = responseJSON.supplierOverview
          nextState.status = null
        }
      }
      this.setState(nextState)
    })
  }

  getOrdersBySupplierID(supplierID = null) {
    const params = {}
    if (supplierID !== null && supplierID !== undefined && supplierID !== '') {
      params.supplierID = Number(supplierID)
    }
    this.setState({ purchaseOrdersLoading: true })
    GET('purchaseOrders/getOrdersBySupplierID', params)
      .then(responseJSON => {
        this.setState({
          purchaseOrders: Array.isArray(responseJSON) ? responseJSON : responseJSON ? Object.values(responseJSON) : [],
          purchaseOrdersLoading: false,
          status: null
        })
      })
      .catch(err => {
        console.error('getOrdersBySupplierID error:', err)
        this.setState({ purchaseOrdersLoading: false, status: STATUS.FETCHING_ERROR })
      })
  }

  async createPurchaseOrderFromOverview({ supplierID, orderlines }) {
    try {
      if (!supplierID || !Array.isArray(orderlines) || orderlines.length === 0) return

      let supplierUID = orderlines[0]?.supplierUID || orderlines[0]?.product?.supplier?.supplierUID || null

      if (!supplierUID && supplierID) {
        let suppliers = this.state.suppliers || []
        if (!suppliers.length) {
          const responseJSON = await GET('suppliers/pool')
          if (Array.isArray(responseJSON)) {
            suppliers = responseJSON
            this.setState({ suppliers })
          }
        }
        const supplierObj = suppliers.find(s => Number(s.SupplierID) === Number(supplierID))
        supplierUID = supplierObj?.supplierUID || null
      }

      if (!supplierUID) {
        console.error('Missing supplier (supplierUID). Cannot create purchase order.')
        return
      }

      const isDropShip = Boolean(orderlines[0]?.isDropShip ?? orderlines[0]?.isDropship ?? orderlines[0]?.product?.supplier?.isDropship)
      const mappedLines = orderlines.map(l => ({
        vendor: l.supplierUID || l?.product?.supplier?.supplierUID || supplierUID,
        ProductID: l.ProductID,
        VariationID: l.VariationID,
        variationUID: l.variationUID ?? null,
        productTitle: l.productTitle ?? '',
        count: l.count ?? 0,
        OrderlineID: l.OrderlineID ?? null,
        PurchaseOrderLineNote: l.PurchaseOrderLineNote ?? null,
        address: l.address || '',
        phone: l.phone || '',
        email: l.email || '',
        isDropShip: l.isDropShip ?? isDropShip,
        OrderID: l.OrderID || null,
        productPrice: l.productPrice || 0
      }))

      const orderlineIDs = mappedLines.map(l => l.OrderlineID).filter(Boolean)
      if (orderlineIDs.length) {
        await this.applyStatusFromOrderlines(orderlineIDs, isDropShip)
      }

      PurchaseOrderStoreActions.generatePurchaseOrder(mappedLines)
    } catch (e) {
      console.error('Failed to create purchase order from overview:', e)
    }
  }

  async applyStatusFromOrderlines(orderlineIDs = [], isDropShip = false) {
    if (!Array.isArray(orderlineIDs) || orderlineIDs.length === 0) return
    const target = isDropShip ? 'SHIPPED' : 'ORDERED'
    try {
      const res = await POST('orders/apply-status-from-lines', {
        orderlineIDs,
        isDropship: Boolean(isDropShip)
      })
      if (res && !res.error) {
        toast.success(`Applied status ${target} to selected orderlines`, {
          autoClose: 3000,
          onClose: () => {
            OrderActions?.clearToast && OrderActions.clearToast()
          }
        })
        this.getPurchaseOrderOverview()
      } else {
        toast.error(`Failed applying status ${target}`)
      }
    } catch (e) {
      console.error('applyStatusFromOrderlines failed:', e)
      toast.error(`Failed applying status ${target}`)
    }
  }

  reportPurchaseOrderError(linesWithError) {
    this.setState({ status: STATUS.IS_SAVING })
    POST('purchaseOrders/reportPurchaseOrderError', linesWithError).then(responseJSON => {
      if (responseJSON && !responseJSON.error) {
        this.setState({ status: STATUS.UPDATE_SUCCESS })
      } else {
        this.setState({ status: STATUS.UPDATE_ERROR })
      }
    })
  }

  setEANonVariation(VariationID, EAN) {
    POST('products/add-ean', { VariationID, EAN }).then(response => {
      let nextState = {}
      if (response.error) {
        nextState.status = STATUS.PRODUCT_ERROR
      } else {
        nextState.status = STATUS.PRODUCT_SUCCESS
      }
      this.setState(nextState)
    })
  }
}
